/**
 * Cómo se le dice a cada rol delante de la persona.
 *
 * Vivía dentro de BarraSuperior, que es un sitio raro para una verdad del
 * negocio: en cuanto el menú lateral necesitó decir el mismo cargo, la opción
 * era importarlo de un componente de maquetación o volver a escribirlo. Las
 * dos son formas de que un día «Gerente operativo» se llame distinto en dos
 * pantallas.
 */
export const NOMBRE_ROL = {
  gerencia: 'Gerencia',
  gerente_operativo: 'Gerente operativo',
  /*
   * LA CLAVE DICE «programacion» Y EL RÓTULO DICE «Proyectos», A PROPÓSITO.
   *
   * En MEGA ese cargo se llama Proyectos —así entraron Jimmy, Juan Diego y
   * Luis Fernando en la nómina de la 0064— y así lo pidió Johan que se lea.
   * La clave se queda como está porque es el valor del enum `rol_usuario` en
   * la base: cambiarla obligaría a tocar políticas, permisos y funciones para
   * arreglar una palabra que solo se ve en pantalla.
   *
   * Si alguien viene un día a «corregir» esta incoherencia, que sepa que es
   * deliberada.
   */
  programacion: 'Proyectos',
  operario: 'Operario',
  administrador: 'Administrador',
  bodega: 'Bodega',
  cartera: 'Cartera',
} as const

export type ClaveRol = keyof typeof NOMBRE_ROL
